export const redirectToRoute = (type) => {
  return { type: type };
};
